import { useQuery } from '@tanstack/react-query';

import { getReviewContext } from '../../lib/api/endpoints';

export const tradeReviewKeys = {
  all: ['trade-reviews'] as const,
  context: (tradeId: string | null) => [...tradeReviewKeys.all, 'context', tradeId] as const,
};

export function useReviewContext(tradeId: string | null) {
  return useQuery({
    queryKey: tradeReviewKeys.context(tradeId),
    queryFn: () => getReviewContext(tradeId ?? ''),
    enabled: Boolean(tradeId),
  });
}
